module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      hidden: this.$store.state.isLoaded === false
    }
  }, [_c('main-layout', {
    attrs: {
      "ResizeCallback": _vm.resize
    }
  }, [_c('div', {
    style: ({
      'height': this.PageHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "tabMenu"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "margin": "0 auto"
    }
  }, [_vm._l((_vm.AuthData), function(item, index) {
    return [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.tabToggle(index)
        }
      }
    }, [_c('div', {
      staticClass: "tabItem",
      class: {
        active: item.IsActive
      }
    }, [_vm._v(_vm._s(item.Name))])])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "Content"
  }, [_vm._l((_vm.AuthData), function(tabData, index) {
    return [_c('div', {
      class: {
        hidden: !tabData.IsActive
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_c('img', {
      staticClass: "iconMark",
      attrs: {
        "src": require("../assets/img/tableau reports.svg")
      }
    }), _vm._v(" REPORTS\n                    "), _c('update-date', {
      attrs: {
        "UpdateDateList": tabData.UpdateDateList
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "menu"
    }, [_vm._l((tabData.Categories), function(category, index) {
      return [_c('a', {
        attrs: {
          "href": '#' + category.Category.UniqueCategoryName
        }
      }, [_c('div', {
        key: category.Category.CategoryId,
        class: 'tag Color' + (index % 8 + 1),
        style: ((category.IsHidden ? 'opacity:0.4' : 'opacity:1'))
      }, [_c('img', {
        staticClass: "iconMark iconPadding",
        attrs: {
          "src": require("../assets/img/marketing standard -W.svg")
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "tagContent"
      }, [_vm._v("\n                                      " + _vm._s(category.Category.CategoryName) + "\n                                  ")]), _vm._v(" "), _c('a', {
        attrs: {
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            _vm.tagToggle(category)
          }
        }
      }, [_c('div', {
        staticClass: "tagSign",
        class: (category.IsHidden ? 'tagHide' : 'tagSign')
      })])])])]
    })], 2), _vm._v(" "), _vm._l((tabData.Categories), function(category, index) {
      return _c('report-category', {
        key: category.CategoryId,
        attrs: {
          "category": category,
          "color": 'Color' + (index % 8 + 1)
        }
      })
    })], 2)]
  })], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-31365b1e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
// module id = 476
// module chunks = 2